import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/monitoring-observability/page.tsx");
